/**
*
*   Article Snippet
*       - The Signup Area on the Footer
*
**/
'use client';

import Image from '@/components/image';
import Button from '@/components/button';
import ReadTime from '@/components/blog/read-time';
import Tags from '@/components/blog/tags';
import Article from '@/libraries/article';
import { Link } from '@/components/link';
import { useTranslations } from 'next-intl';


//Build the Element
export default function Featured({ children, article, ...props }){

	//Get the Translations
	const t = useTranslations();

	//Return
	return (
		<article className="snippet">
			<div className="image">
				<Link href={ `/blog/${  article.blog.handle  }/${  article.handle }` }>
					{ Article.is.video( article ) && (
						<span className="icons">
							<i className="far fa-play-circle"></i>
						</span>
					)}
					<Image src={ article.image.url } alt="" width="448" height="308" />
				</Link>
			</div>
			<div className="details">
				<Tags article={ article } />
				<ReadTime article={ article } />
			</div>
			<h3>
				<Link href={ `/blog/${  article.blog.handle  }/${  article.handle }` }>
					{ article.title }
				</Link>
			</h3>
			<p>{ Article.excerpt( article ) }</p>
			<div className="buttons">
				<Button href={ `/blog/${  article.blog.handle  }/${  article.handle }` }>
					<span>
						{ t('Pages.Blog.read-more') }
					</span>
				</Button>
			</div>
		</article>
	);

}